import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const usePrefetchApprovalNotification = isLogged => {
  const queryClient = useQueryClient();
  queryClient.prefetchQuery({
    queryKey: ['approval-notification'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/notifications/has-pending-approval-notification');
      return response.data;
    },
    // 30 min
    staleTime: 1800000,
    enabled: !!isLogged,
  });
};

export const useApprovalNotification = (isLogged, forcedFetch = false) => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['approval-notification'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/notifications/has-pending-approval-notification');
      return response.data;
    },
    throwOnError: errorMessage,
    staleTime: forcedFetch ? 0 : 1800000,
    enabled: !!isLogged,
  });
  return query;
};
